<template>
  <empty-state class="margin-auto mt-12">
    <template #icon>
      <v-progress-circular
        color="primary"
        data-testid="backup-and-restore-provisioning-loader"
        indeterminate
        size="80"
      />
    </template>
    <template #description>
      <div class="mt-2">{{ $t("cloudBackupAndRestore.provisioning.title") }}</div>
    </template>
    <template #button>
      <v-btn
        color="primary"
        data-testid="backup-and-restore-provisioning-refresh-btn"
        rounded
        size="large"
        @click="$emit('refresh')"
      >
        {{ $t("general.refresh") }}
      </v-btn>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmptyState from "@/components/EmptyState.vue";

export default defineComponent({
  components: {
    EmptyState,
  },
  emits: ["refresh"],
});
</script>

<style lang="scss" scoped></style>
